/**
 * Block save component
 */
const render = () => {
  return null;
};

export default render;
